export default {
  zh: {
    general: {
      customer: "客戶",
      product_group: "產品組",
      id: "使用者",
      name: "名稱",
      actions: "動作",
      reports: "報告",
      report: "報告",
      products: "產品",
      unit: "單位",
      format: "格式",
      category: "類型",
      shortcut: "捷徑",
      waiting: "等待中",
      in_progress: "進行中",
      text: "內容",
      delete: "刪除",
      move: "移動",
      completed: "已完成",
      confirm: "確認",
      cancel: "取消",
      save: "儲存",
      saving: "儲存中",
      save_order: "依序儲存",
      edit: "編輯",
      remove: "移除",
      clear: "清除",
      select: "選取",
      search: "搜尋",
      overwrite: "替換",
      created: "新增",
      date: "日期",
      please_wait_data_from_cedoon: "數據在CEDOON檢索中，請等待。",
      loading_data: "數據輸入中",
      deleting: "刪除中",
      copied_to_clipboard: "複製到剪貼板",
      supervisor_name: "主管的名字",
      measurements: "測量",
      sheets: "表單",
      最小值: "min",
      最大值: "max",
      test_template: "測試表格",
      value_required: "需要數值",
      或: "or",
      布林質: "boolean",
      可選則: "optional",
      order: "順序",
      print: "列印",
      email: "電子信件",
      password: "密碼",
      base_data: "基本數據",
      search_criteria: "搜尋條件",
      從: "from",
      到: "to",
      data: "數據",
      select_or_drop_file_here: "選取或在此拖放文件",
      error: {
        error: "錯誤",
        title: "發生錯誤",
        generic_error: "請稍後再試",
        loading_data: "加載數據時發生錯誤",
        id_doesnt_exist: "提供的ID不存在或發生錯誤",
        oops: "糟糕，這不應該發生!",
        communication_error: "發生通信故障，請檢查您的網路連接並與您的管理人員連繫。"
      },
      success: "成功",
      administration: " 管理",
      files: " 上傳文件",
      drop_file_here: "將文件放在此處或單擊以點選文件",
      description: "描述",
      submit_report: "提交報告",
      complete_report: "完成報告",
      critical: "關鍵",
      max_diff: "最大 Δ"
    },
    portal: {
      page_header: "頁眉",
      logout: "登出",
      dashboard: "儀表板",
      create_report: "新增並管理報告",
      manage_reports: "管理報告",
      search_reports: "搜尋報告",
      view_report: "瀏覽報告",
      change_language: "語言"
    },
    login: {
      credentials_dont_match: "這些憑證與我們的記錄都不相符",
      login: "將我登入",
      enter_email: "輸入您的電子信箱地址",
      enter_password: "輸入您的密碼"
    },
    reports_index: {
      create_new: "新增報告",
      no_reports_waiting: "無等待中報告",
      no_reports_in_progress: "無處理中報告",
      no_reports_completed: "無已經完成報告",
      measurements_done: "測量完成",
      no_reports_finished_measurement: "無已完成測量報告",
      no_reports_found: "查無此報告",
      dialog: {
        delete_message: "您真的要刪除<strong>{report_number} - {report_name}</strong>嗎?"
      }
    },
    reports_search_list: {
      test_report_list: "測試報告清單"
    },
    report: {
      report_information: "報告資訊",
      report_no: "報告編號",
      description: "報告摘要",
      customer_name: "客戶名稱",
      customer_order_no: "客戶訂單號碼",
      supplier_name: "供應商名稱",
      supplier: "供應商",
      plant: "工廠",
      shipping_date: "出貨日期",
      order_date: "订购日期",
      checked_with: "檢查",
      product_information: "產品資訊",
      article_no: "貨品編號",
      charge: "批次",
      surface: "表面",
      head: "頭部",
      head_stamp: "頭標",
      recess: "承穴",
      recess_size: "承穴尺寸",
      thread_type: "牙型",
      point: "牙尾",
      drawing_no: "圖號",
      batch: "批次",
      material_certificate: "材料證書",
      heat_nr: "爐號",
      order_quantity: "訂單數量",
      sheet_amount: "（無工作表）| （1工作表）| （{amount}工作表）",
      wood_information: {
        wood_information: "木料資訊",
        wood_no: "木料編號",
        insertion_direction: "插入方向",
        wood_moisture: "木料濕度",
        wood_density: "木料密度",
        room_temperature: "室內溫度",
        room_moisture: "室內溼度"
      },
      progress: "進展",
      customer: "客戶",
      data_validation: "測試結果",
      attachments_for: "附件",
      loading_report: "報告傳輸中",
      loading_reports: "報告傳輸中",
      error_loading_report: "報告傳輸發生錯誤",
      template: "表格",
      sales_contract: "銷售合約",
      screw_type: "螺絲種類",
      screw_diameter: "螺絲直徑",
      screw_length: "螺絲長度",
      no_samples: "樣品數",
      customer_drawing_number: "客戶圖號",
      work_order_nr: "工單號",
      attachments: "附件",
      no_attachments: "該報告沒有任何附件。",
      no_attachments_sheet: "此工作表沒有任何附件。",
      upload: {
        title: "上傳文件",
        wrong_file_type: "文件類型錯誤（僅PNG / JPG / PDF）",
        upload_file: "上傳文件"
      },
      success: {
        measurements: {
          message: "測量結果成功儲存"
        },
        info: {
          message: "報告信息已成功儲存"
        },
        wood_info: {
          message: "木材信息成功儲存"
        },
        sheet_info: {
          message: "工作表信息已成功保存"
        }
      }
    },
    reports_show: {
      dialog: {
        message: "您要刪除此附件嗎"
      },
      no_report_found: "查無此報告",
      no_report_found_url: "此網址無法找到任何報告"
    },
    reports_create: {
      heading: "新增報告",
      configure_heading: "編輯報告",
      report_data: "報告數據",
      report_data_description: "請填寫報告基本資料",
      checking_report_number: "查詢報告編號",
      number_in_use: "此編號使用中",
      use_instead: "請改用{number} ",
      number_available: "此數字可供使用",
      add_product: "新增產品",
      select_products: "請選擇要查看此報告的產品",
      bulk_import_measurements: "匯入整批測量值",
      select_test_template: "選取測試表格",
      import_measurements: "匯入測量值",
      some_characteristics_wont_be_imported: "某些性質不會顯示在測試表格上，因此不會將其導入。 （標示為橙色）",
      overwrite_dialog: {
        message: "此報告已包含測量值。<br/>您要<strong>覆蓋</strong>現有資料嗎?"
      },
      bulk_overwrite_dialog: {
        message: "以下產品皆已包含數據。<br/>{overwrittenText} 您要<strong>覆蓋</strong>所有產品的資料嗎?"
      },
      delete_dialog: {
        message: "該工作表可能已經包含數據。<br/> 您要刪除嗎？",
        success: "已成功從報表中刪除工作表。",
        error: "取出紙張時發生錯誤。請稍後再試！"
      }
    },
    reports_search: {
      heading: "搜尋報告"
    },
    reports_view: {
      heading: "瀏覽報告",
      enter_charge_and_article_no: "請輸入批號與產品編號",
      select_at_least_one_characteristic: "選擇至少一個特質"
    },
    reports_print: {},
    products: {
      description: "產品描述",
      import: "匯入產品",
      add_new: "加入新產品",
      loading_products: "產品傳輸中",
      no_products_available: "無產品可用",
      no_products_found: "沒有找到產品",
      start_by_adding_new_products: "首先加入新產品",
      error_deleting: "刪除產品時發生錯誤",
      success_deleting: "成功刪除產品",
      deletion_text: "您是否真的要刪除<strong> {description} </ strong>？",
      use_proposed_value: '使用建議的描述 "{description}"'
    },
    products_edit: {
      heading: "編輯產品",
      master_data: "主要資料",
      assign_test_template: "分配測試表格",
      add_test_template: "加入測試表格",
      range_value: "範圍/數值",
      no_test_templates: "没有可用的测试表格",
      test_template_remove_try_dialog: {
        message: "此測試表格用於報告中，無法從產品中移除。"
      },
      remove_template_dialog: {
        message: "您要從此產品中移除<strong>' + {templateName} + '</strong> ?<br/>這個指令將立即執行並且無法回復。"
      }
    },
    products_create: {
      heading: "新增產品",
      enter_properties: "輸入產品屬性"
    },
    products_import: {
      heading: "從檔案中匯入",
      step_1: "步驟1 -匯入產品",
      import_data: "匯入數據",
      importing_data: "數據匯入中",
      import_successful: "匯入完成",
      need_help: "需要協助嗎?",
      need_help_text_columns_allowed:
        "允許使用下列 {column}  (which means, that these columns can appear multiple times)",
      need_help_text_columns_required: "下列欄位資料必須提供",
      step_2: "步驟2 - 連結特質",
      article_number_of_product: "產品料號",
      which_template: "將採用的表格",
      shorthand_of_characteristic: "特質的簡寫",
      target_value: "目標數值",
      ok_nok_field: "ok/nok 欄",
      sequence_of_characteristics: "特質顯現的順序",
      特質_連結: "characteristic_key",
      validate: "驗證資料",
      is_validating: "驗證中",
      errors_occurred: "發現錯誤，請於檢查下表並在錯誤修復後檢視表格並重新上傳檔案。",
      clear: "清除",
      errors: {
        MISSING_REQUIRED_PROPERTY: "缺少所需的屬性",
        UNALLOWED_MULTIPLE_VALUES: "在單值屬性上找到多個值",
        UNKNOWN_VALUE: "在選取屬性上找到未知值",
        COMPANY_DOES_NOT_EXIST: "公司不存在",
        PRODUCT_EXISTS: "給予商品編號和客戶的產品已存在",
        TEMPLATE_DOES_NOT_EXIST: "測試表格不存在",
        PRODUCT_DOES_NOT_EXIST: "產品不存在",
        CHARACTERISTIC_NOT_ASSIGNED: "特質未指定到測試表格",
        UNKNOWN_CHARACTERISTIC: "找到未知的特征ID"
      }
    },
    products_search: {
      choose_products: "選取產品",
      add_selected_products: "新增選取產品",
      multiple_customers_error: "您只能添加來自同一客戶的產品"
    },
    calculation: {
      rtor_k1: "抗扭強度特質_5",
      rtor_k2: "抗扭強度特質_95",
      rtor_mw: "平均抗紐強度_avg",
      ftor_k1: "斷裂扭力特質",
      fax_k1: "拔出參數特質",
      my_k1: "降伏點特質",
      fhead_k1: "頭部拉穿參數特質",
      ftens_k1: "拉力特質",
      tor_rat_1: "扭力比_5",
      tor_rat_2: "扭力比_95",
      tor_rat_3: "扭力比_avg",
      ftor_k1_raw: "斷裂扭力特質_raw",
      rtor_k1_raw: "抗扭強度特質_5raw",
      rtor_k2_raw: "抗扭強度特質_95raw",
      rtor_mw_raw: "平均抗紐強度_avgraw"
    },
    characteristics: {
      product_characteristics: "產品特質",
      characteristic: "特質",
      characteristics: "特質",
      assign_characteristics: "指定特質",
      assigned_characteristics: "指定特質",
      loading_characteristics: "特質傳輸中",
      already_in_use: "此特質已被採用且無法刪除",
      available_characteristics: "可用特質",
      critical_characteristic: "關鍵特性"
    },
    characteristics_index: {
      add_new: "加入新增特質",
      no_characteristics_available: "無可用特質",
      start_by_adding_new_characteristics: "從加入新增特質開始",
      dialog: {
        message: "您要刪除 <strong>{localizedKey}</strong>?"
      }
    },
    characteristics_create: {
      heading: "新增新產品特質",
      error_while_creating: "新特質新增時發生錯誤"
    },
    templates_index: {
      create_new: "新增一個測試表格",
      loading_templates: "測試表格傳輸中",
      no_templates_available: "無測試表格可使用",
      start_by_adding_a_new_template: "從新增新測試表格開始"
    },
    templates_create: {
      create_new: "新增一個測試表格",
      selected_characteristics: "選取的特質",
      available_characteristics: "可用特質"
    },
    template_view: {
      title: "測試表格: {name}",
      info_text: "您可以通過拖放更該特質的順序",
      assigned_characteristics: "指定特質",
      loading: {
        title: "測試表格傳輸中",
        subtitle: "測試報告在Cedoon檢索時請等待",
        error: {
          title: "測試表格傳輸時發生錯誤",
          subtitle: "提供的ID不存在或發生錯誤"
        }
      },
      saving: {
        success: "特性的順序已成功儲存",
        button: "儲存特質順序"
      }
    },
    characteristic_titles: {
      report_number: "檢驗報告編號",
      screw: "螺絲",
      test_acc: "測試規範",
      valid_from: "有效日期始於",
      supplier_name: "供應商",
      sales_contract: "確認訂單",
      shipping_date: "出貨日",
      size: "規格",
      work_order: "制令",
      customer_name: "客戶",
      head: "頭型",
      thread: "螺牙",
      point: "螺尾",
      recess: "針型",
      customer_order_name: "訂單編號",
      surface: "表面處理",
      drawing_no: "圖號",
      head_mark: "頭標",
      article_number: "商品編碼",
      batch: "批量(次)",
      material_certificate: "材質證明書",
      heat_no: "材證爐號",
      insp_items: "檢驗項目",
      shippment_date: "出貨日",
      wood_nr: "木塊編號",
      insertion_direction: "旋入方向",
      wood_moisture: "木塊濕度",
      wood_density: "木塊密度",
      room_temperature: "室內溫度",
      room_moisture: "室內溼度"
    },
    data_types: {
      TEXT: "樣品註記",
      FLOAT: "樣品的數值",
      BOOLEAN: "樣品OK/NOK",
      ONE_BOOLEAN_PER_CHARACTERISTIC: "樣品特性OK/NOK",
      ONE_FLOAT_PER_CHARACTERISTIC: "樣品特性的數值",
      ONE_BOOLEAN_PER_PRODUCT: "產品OK/NOK",
      ONE_TEXT_PER_PRODUCT: "產品註記"
    },
    file_upload: {
      title: " 上傳文件",
      category_file: " 選擇類別並選擇文件",
      category: " 類別",
      file_name: " 檔案名稱",
      mc: "材料证明书",
      company: "公司",
      dropzone: {
        text: " 將文件放在此處或點擊以選擇文件",
        allowed_file_types: " 允許的文件類型：{類型}",
        wrong_file_type: " 不允許的文件類型",
        please_select: " 將文件放在此處或點擊以選擇文件"
      },
      saving: {
        button: " 上傳",
        error: " 上傳文件時出錯，請再試一次。",
        success: " 文件成功上傳",
        file_exists: " 相同名稱的文件已存在"
      }
    },
    files: {
      loading: {
        title: " 檔案載入中",
        subtitle: " CEDOON檢索文件時，請等待",
        error: {
          title: " 加載文件時出錯",
          subtitle: " 請稍後再試"
        }
      },
      title: " 上傳文件",
      header: {
        file_name: " 檔案名稱",
        category: " 類別",
        uploaded_by: " 上傳者"
      }
    },
    print_report_dialog: {
      title: "列印成PDF",
      subtitle: "設定值",
      layout: "設計",
      language: "語言",
      generate: "產生PDF",
      save: "储存PDF",
      open: "开启PDF",
      send: "发送PDF",
      recipient: "收件人电子邮件",
      recipient_text: "请输入收件人的电子邮件地址",
      recipient_valid_email: "请输入有效的电子邮件地址！",
      attachments: {
        title: "包括附件",
        pdf: "PDF附件",
        image: "图片附件",
        characteristic: "测试报告特征相关的附件",
        material_certificate: "材料证明书",
        technical_drawing: "技术图档"
      }
    },
    layouts: {
      STANDARD: "標準",
      DECKMATE: "Deckmate",
      DEMO: "展示"
    },
    submit_report: {
      error: "請輸入您的名字！",
      text: "請輸入您的姓名以提交此報告。 提交後，您將無法編輯報告！",
      success: "報告成功提交"
    },
    report_step: {
      CREATED: "等候",
      IN_PROGRESS: "進行中",
      DONE_GATHERING: "測量完成",
      COMPLETED: "已發表"
    },

    report_filter: {
      heading: "篩選報告",
      timeframe: "時間範圍",
      one_week: "1周",
      one_month: "1個月",
      one_year: "1年",
      progress: "進展",
      customer: "客戶",
      data_validation: "測試結果",
      number_of_reports_by_status: "按狀態的報告數量",
      please_click_tiles_to_choose: "請點擊以選擇文件",
      quickfilter: "快速篩選",
      screw_length: "螺絲長度",
      screw_diameter: "螺桿直徑"
    },
    complete_report: {
      error: "請輸入您的名字！",
      text: "請輸入您的姓名以完成此報告",
      success: "報告成功發布"
    }
  }
};
